export const getKeycloakUser = () => {
    const keycloakData = sessionStorage.getItem(
      import.meta.env.VITE_KEYCLOAK_USER_STORAGE_KEY
    );
    return keycloakData ? JSON.parse(keycloakData) : null;
  };
  
  export const getKeycloakTokens = () => {
    const keycloakUser = getKeycloakUser();
    return {
      access_token: keycloakUser?.access_token || "",
      id_token: keycloakUser?.id_token || "",
      refresh_token: keycloakUser?.refresh_token || "",
      expires_at: keycloakUser?.expires_at || 0,
    };
  };




